import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import Button from 'design-system/components/Button';
import Stack from 'design-system/components/Stack';
import { Heading, Paragraph } from 'design-system/components/Text';
import NotFoundIllustration from 'images/dashboard/not-found.svg';

const ErrorStateWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const EmptyImage = styled(NotFoundIllustration)`
  max-width: 600px;
  height: auto;
  margin-left: 180px; // Visually center the image
`;

const Header = styled(Stack)`
  margin-top: ${Spacing[9]};
  margin-bottom: ${Spacing[8]};
  text-align: center;
`;

const ErrorState = () => {
  return (
    <ErrorStateWrapper>
      <EmptyImage />
      <Header>
        <Heading size='lg'>Sorry!</Heading>
        <Paragraph size='lg' color='primary'>
          Something went wrong. Refresh and try again?
        </Paragraph>
      </Header>

      <Button onClick={() => window.location.reload()} width='button'>
        Refresh
      </Button>
    </ErrorStateWrapper>
  );
};

export default ErrorState;
